import { Drawer, Menu } from 'antd'
import { useThemeMode } from '@/app/theme/useThemeMode'
import { NetlinkLogo } from '@/shared/ui/NetlinkLogo'
import { useSidebarMenu } from './useSidebarMenu'

interface MobileNavDrawerProps {
  open: boolean
  onClose: () => void
}

/**
 * Chap navigatsiya — TOR EKRAN uchun suzuvchi panel.
 *
 * `AppSider` bilan BIR XIL menyu mantig'i (`useSidebarMenu`) — faqat qobiq
 * boshqacha: doimiy ustun o'rniga hamburger tugma bilan ochiladigan Drawer.
 * Element bosilganda DARHOL yopiladi — aks holda operator sahifaga o'tgach
 * ham panel ekranni yopib turardi.
 */
export function MobileNavDrawer({ open, onClose }: MobileNavDrawerProps) {
  const { isDark } = useThemeMode()
  const menu = useSidebarMenu(false)

  return (
    <Drawer
      title={<NetlinkLogo variant="compact" height={24} onDark={isDark} />}
      placement="left"
      open={open}
      onClose={onClose}
      width={280}
      styles={{ body: { padding: 0 } }}
    >
      <Menu
        mode="inline"
        items={menu.items}
        selectedKeys={[menu.selectedKey]}
        openKeys={menu.openKeys}
        onOpenChange={menu.onOpenChange}
        onClick={(info) => {
          menu.onClick?.(info)
          onClose()
        }}
      />
    </Drawer>
  )
}
